module.exports = __webpack_public_path__ + "static/img/3.bc69a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/3.png
// module id = +w3o
// module chunks = 19